import { FieldErrors } from "react-hook-form";

/**
 * The form labels, keyed by field name. Used to tell the user which fields are
 * blocking a save: the form does not focus the first invalid field, so without
 * this a failed validation looks like the Save button doing nothing at all.
 */
const FIELD_LABELS: Record<string, string> = {
  contractTypeId: "Type of project",
  customerCategory: "Customer Category",
  name: "Name",
  surname: "Surname",
  companyName: "Company name",
  contactName: "Contact Name",
  title: "Title",
  email: "Email",
  phone: "Phone",
  mobile: "Mobile",
  fax: "Fax",
  website: "Website",
  country: "Country",
  state: "State",
  city: "City",
  ZIP: "ZIP",
  address: "Address",
  billingContact: "Billing contact",
  billingAddress: "Billing Address",
  billingState: "Billing State",
  billingCity: "Billing City",
  billingZIP: "Billing ZIP",
  depositAmount: "Deposit amount",
  estimatedStartDate: "Estimated start date",
  laborGoalHours: "Labor goal - hours",
  laborGoalBudget: "Budget",
  createdDate: "Date Added to System",
};

export const describeInvalidFields = (errors: FieldErrors<any>): string =>
  Object.keys(errors ?? {})
    .map((field) => FIELD_LABELS[field] ?? field)
    .join(", ");
